import { AppState } from "@app/store/reducers";
import { AgencyState } from "@app/store/reducers/agency.reducer";
import { createSelector } from "reselect";

const getAgencyState = (state: AppState): AgencyState => state.agency;

export const selectAgency = createSelector(getAgencyState, (state) => {
  return state.agency;
});
